const CHATBOT_MAX_OPTIONS_LENGTH = 5;
const CHATBOT_MAX_OPTIONS_MESSAGE = `Maximum ${CHATBOT_MAX_OPTIONS_LENGTH} options are allowed for this experience type.`;

export default {
  CHATBOT_MAX_OPTIONS_LENGTH,
  CHATBOT_MAX_OPTIONS_MESSAGE,
};
